const WheelTypes = {
  first: 0,
  second: 1,
  third: 2,
};

Object.freeze(WheelTypes);

export { WheelTypes };
